import {
  IonButton,
  IonCard,
  IonCardContent,
  IonCol,
  IonContent,
  IonGrid,
  IonIcon,
  IonItem,
  IonLabel,
  IonLoading,
  IonPage,
  IonRow,
  IonSelect,
  IonSelectOption,
  IonSkeletonText,
  IonText,
  IonToast,
} from "@ionic/react";
import { printOutline } from "ionicons/icons";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useState } from "react";
import Header from "../../components/Header";
import { AuthContext } from "../../providers/authContext";
import userService from "../../services/UserService";
import { EmlakBildirim } from "../entities/EmlakBildirim";
import "./Page.css";
import { useLocation } from "react-router";

const EmlakBildirimSorgu: React.FC = () => {
  const { setTitle } = React.useContext(AuthContext);
  const location = useLocation();
  const [showLoading, setShowLoading] = useState<boolean>(false);
  const [showToastMessage, setShowToastMessage] = useState<string>();
  const [bildirimTipi, setBildirimTipi] = useState<string>();
  const [bildirimTuru, setBildirimTuru] = useState<string>();
  const loadingData = [
    {
      tur: "",
      tip: "",
      beyanNo: "",
      kapiNo: "",
      bagNo: "",
      katNo: "",
      blokNo: "",
      paftaNo: "",
      adaNo: "",
      parselNo: "",
    },
    {
      tur: "",
      tip: "",
      beyanNo: "",
      kapiNo: "",
      bagNo: "",
      katNo: "",
      blokNo: "",
      paftaNo: "",
      adaNo: "",
      parselNo: "",
    },
    {
      tur: "",
      tip: "",
      beyanNo: "",
      kapiNo: "",
      bagNo: "",
      katNo: "",
      blokNo: "",
      paftaNo: "",
      adaNo: "",
      parselNo: "",
    },
    {
      tur: "",
      tip: "",
      beyanNo: "",
      kapiNo: "",
      bagNo: "",
      katNo: "",
      blokNo: "",
      paftaNo: "",
      adaNo: "",
      parselNo: "",
    },
  ];
  const [loading, setLoading] = useState<boolean>(false);
  const loadingColumnArray = [
    { field: "tur", header: "Türü" },
    { field: "tip", header: "Tip" },
    { field: "beyanVerilisSekli", header: "Veriliş Şekli" },
    { field: "beyanNo", header: "Beyan No" },
    { field: "kapiNo", header: "Kapı No" },
    { field: "bagNo", header: "Bağ. No" },
    { field: "katNo", header: "Kat No" },
    { field: "blokNo", header: "Blok No" },
    // { field: "paftaNo", header: "Pafta No" },
    { field: "adaNo", header: "Ada No" },
    { field: "parselNo", header: "Parsel No" },
  ];
  const [sonuc, setSonuc] = useState<EmlakBildirim[]>([]);

  React.useEffect(() => {
    setTitle("Emlak Bildirim Sorgulama");
    // Extract query parameters from the location
    const searchParams = new URLSearchParams(location.search);
    const bildirimTipi = searchParams.get('bildirimTipi');
    const bildirimTuru = searchParams.get('bildirimTuru');
    if (bildirimTipi && bildirimTuru) {
      setBildirimTipi(bildirimTipi);
      setBildirimTuru(bildirimTuru);
      getEmlakBildirim();
    }
  }, []);

  const getEmlakBildirim = (event?: any) => {
    if (event) {
      event.preventDefault();
    }
    setLoading(true);
    userService
      .getEmlakBildirim(bildirimTipi, bildirimTuru)
      .then((data: EmlakBildirim[]) => setSonuc(data))
      .catch((error) => {
        if (error.response) {
          // Request made and server responded
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);
        } else if (error.request) {
          // The request was made but no response was received
          console.log(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log("Error", error.message);
        }
        setShowToastMessage(
          error.response ? error.response.data.message : error
        );
      })
      .finally(() => setLoading(false));
  };

  const raporGoster = (actionURL: string, id: string) => {
    setShowLoading(true);
    userService
      .bildirimRaporuYazdir(actionURL, id)
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "emlak.bildirim.rapor.pdf");
        document.body.appendChild(link);
        link.click();
      })
      .catch((error) => {
        if (error.response) {
          // Request made and server responded
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);
        } else if (error.request) {
          // The request was made but no response was received
          console.log(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log("Error", error.message);
        }
        setShowToastMessage(
          error.response ? error.response.data.message : error
        );
      })
      .finally(() => setShowLoading(false));
  };

  const loadingBodyTemplate = (header: string) => {
    return <IonSkeletonText animated />;
  };

  const bodyTemplate = (header: string, field: string, rowData: any) => {
    return <IonText>{rowData[field]}</IonText>;
  };

  const detayTemplate = (rowData: EmlakBildirim) => {
    return (
      <IonButton
        type="button"
        fill="clear"
        title="Yazdır"
        color="dark"
        onClick={() => raporGoster(rowData.actionURL, rowData.id)}
      >
        <IonIcon icon={printOutline} />
      </IonButton>
    );
  };

  return (
    <IonPage>
      <Header />
      <IonContent fullscreen>
        <IonLoading
          isOpen={showLoading}
          onDidDismiss={() => setShowLoading(false)}
          message={"Lütfen Bekleyin..."}
        />
        <IonToast
          isOpen={showToastMessage !== undefined}
          onDidDismiss={() => setShowToastMessage(undefined)}
          message={showToastMessage}
          duration={2000}
          position="top"
        />
        <form
          onSubmit={(e) => {
            getEmlakBildirim(e);
          }}
        >
          <IonGrid>
            <IonRow>
              <IonCol
                size="4"
                offset="0"
                sizeSm="3"
                offsetSm="1"
                className="ion-hide-sm-down"
              >
                <IonItem className="ion-text-end">
                  <IonLabel>Bildirim Tipi</IonLabel>
                </IonItem>
              </IonCol>
              <IonCol size="10" sizeSm="4" offset="1" offsetSm="0">
                <IonItem className="ion-hide-sm-up">
                  <IonLabel position="floating">Bildirim Tipi</IonLabel>
                  <IonSelect
                    name="bildirimTipiInput"
                    interface="popover"
                    value={bildirimTipi}
                    placeholder="Seçiniz..."
                    onIonChange={(e) => setBildirimTipi(e.detail.value)}
                  >
                    <IonSelectOption value="">Seçiniz</IonSelectOption>
                    <IonSelectOption value="Normal">Normal</IonSelectOption>
                    <IonSelectOption value="Köy">Köy</IonSelectOption>
                  </IonSelect>
                </IonItem>
                <IonItem className="ion-hide-sm-down">
                  <IonSelect
                    name="bildirimTipiInput"
                    interface="popover"
                    value={bildirimTipi}
                    placeholder="Seçiniz..."
                    onIonChange={(e) => setBildirimTipi(e.detail.value)}
                  >
                    <IonSelectOption value="">Seçiniz</IonSelectOption>
                    <IonSelectOption value="Normal">Normal</IonSelectOption>
                    <IonSelectOption value="Köy">Köy</IonSelectOption>
                  </IonSelect>
                </IonItem>
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol
                size="4"
                offset="0"
                sizeSm="3"
                offsetSm="1"
                className="ion-hide-sm-down"
              >
                <IonItem className="ion-text-end">
                  <IonLabel>Bildirim Türü</IonLabel>
                </IonItem>
              </IonCol>
              <IonCol size="10" sizeSm="4" offset="1" offsetSm="0">
                <IonItem className="ion-hide-sm-up">
                  <IonLabel position="floating">Bildirim Türü</IonLabel>
                  <IonSelect
                    name="bildirimTuruInput"
                    interface="popover"
                    value={bildirimTuru}
                    placeholder="Seçiniz..."
                    onIonChange={(e) => setBildirimTuru(e.detail.value)}
                  >
                    <IonSelectOption value="">Seçiniz</IonSelectOption>
                    <IonSelectOption value="Bina">Bina</IonSelectOption>
                    <IonSelectOption value="Arsa">Arsa</IonSelectOption>
                    <IonSelectOption value="Arazi">Arazi</IonSelectOption>
                  </IonSelect>
                </IonItem>
                <IonItem className="ion-hide-sm-down">
                  <IonSelect
                    name="bildirimTuruInput"
                    interface="popover"
                    value={bildirimTuru}
                    placeholder="Seçiniz..."
                    onIonChange={(e) => setBildirimTuru(e.detail.value)}
                  >
                    <IonSelectOption value="">Seçiniz</IonSelectOption>
                    <IonSelectOption value="Bina">Bina</IonSelectOption>
                    <IonSelectOption value="Arsa">Arsa</IonSelectOption>
                    <IonSelectOption value="Arazi">Arazi</IonSelectOption>
                  </IonSelect>
                </IonItem>
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol style={{ textAlign: "center" }}>
                <IonButton type="submit">Sorgula</IonButton>
              </IonCol>
            </IonRow>
          </IonGrid>
          <IonCard>
            <IonCardContent className="datatable-responsive">
              {loading && (
                <DataTable
                  value={loadingData}
                  paginator
                  rows={10}
                  emptyMessage=""
                  removableSort
                  stripedRows
                  size="small"
                  responsiveLayout="stack"
                  breakpoint="960px"
                >
                  {loadingColumnArray.map((col, index) => (
                    <Column
                      key={index}
                      field={col.field}
                      header={col.header}
                      body={() => loadingBodyTemplate(col.header)}
                      headerClassName="ion-text-center"
                    />
                  ))}
                  <Column
                    field="detay"
                    header="Detay"
                    body={() => loadingBodyTemplate("Detay")}
                    headerClassName="ion-text-center"
                  />
                </DataTable>
              )}
              {!loading && (
                <DataTable
                  value={sonuc}
                  paginator
                  rows={10}
                  emptyMessage=""
                  stripedRows
                  size="small"
                  responsiveLayout="stack"
                  breakpoint="960px"
                >
                  {loadingColumnArray.map((col, index) => (
                    <Column
                      key={index}
                      field={col.field}
                      header={col.header}
                      headerClassName="ion-text-center"
                      body={(rowData) =>
                        bodyTemplate(col.header, col.field, rowData)
                      }
                    />
                  ))}
                  <Column
                    field="detay"
                    header="Detay"
                    body={(rowData) => detayTemplate(rowData)}
                    headerClassName="ion-text-center"
                  />
                </DataTable>
              )}
            </IonCardContent>
          </IonCard>
        </form>
      </IonContent>
    </IonPage>
  );
};

export default EmlakBildirimSorgu;
